export const splitPhone = (value, defaultCode = '+1') => {
  const digits = String(value ?? '').replace(/\D/g, '');
  const code = ['1', '91', '44'].find(prefix =>
    digits.startsWith(prefix) && digits.length === prefix.length + 10
  );
  return {
    code: code ? `+${code}` : defaultCode,
    number: code ? digits.slice(code.length) : digits
  };
};
